import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["source"]

  copy(event) {
    event.preventDefault()

    const text = this.sourceTarget?.value || this.sourceTarget?.textContent || ""
    if (!text) return

    const button = event.target
    const originalText = button.textContent

    navigator.clipboard?.writeText(text)
      .then(() => {
        button.textContent = "Copied!"
        button.classList.add("text-green-600")
        setTimeout(() => {
          button.textContent = originalText
          button.classList.remove("text-green-600")
        }, 2000)
      })
      .catch((err) => {
        console.error("Failed to copy:", err)
        button.textContent = "Failed"
        button.classList.add("text-red-600")
        setTimeout(() => {
          button.textContent = originalText
          button.classList.remove("text-red-600")
        }, 2000)
      })
  }
}
